function getSendViaLocation(): string {
  if (typeof window === "undefined") {
    return ""
  }
  return `${window.location.host}${window.location.pathname}`
}

const SEND_VIA_SUFFIX = /\s*Send via .+$/i

export function appendSendVia(
  message: string,
  location: string = getSendViaLocation(),
): string {
  const text = message ?? ""
  if (SEND_VIA_SUFFIX.test(text)) {
    return text
  }
  const base = text.trimEnd()
  return base ? `${base} Send via ${location}` : `Send via ${location}`
}
